var $2db6648255dd48ea$exports = {};
$2db6648255dd48ea$exports = {
    "collapse": `\u{421}\u{432}\u{435}\u{440}\u{43D}\u{443}\u{442}\u{44C}`,
    "expand": `\u{420}\u{430}\u{437}\u{432}\u{435}\u{440}\u{43D}\u{443}\u{442}\u{44C}`
};


export {$2db6648255dd48ea$exports as default};
//# sourceMappingURL=ru-RU.module.js.map
